module.exports = __webpack_public_path__ + "static/media/xrp-icon.8a25ca6b.svg";